// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"177":"BlogDetailPage","460":"HomePage"}[chunkId] + "." + {"177":"98074d10","460":"fcf38ab2"}[chunkId] + ".css";
};